import { useQuery } from '@tanstack/react-query'

import { fetchFields } from '../functions/fetchFields'

function useFetchFields() {
  return useQuery(['fetchFieldDetails'], fetchFields)
}

function useFetchFieldsByCriteria(criteria: string) {
  const { data } = useFetchFields()
  return useQuery({
    queryKey: ['fetchCriteriaDetails', criteria],
    queryFn: () => {
      return data.find(
        (d: { criteriaName: string }) => d.criteriaName === criteria
      )
    },
    enabled: !!data,
  })
}
export { useFetchFieldsByCriteria }
